import { Routes, Route, useNavigationType, useLocation, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLogin } from './Contexts/AuthProvider/AuthProvider';
import ErrolPage from './pages/enroll/EnrollPage';
import Backoffice from 'pages/backoffice/Backoffice';
import { Policies } from 'pages/policies/Policies';
import { Terms } from 'pages/terms/terms';
import { ForgotPasswordPage } from 'pages/forgot-password/ForgotPassword';
import { BackofficeTermsPolicies } from 'pages/backoffice-terms-policies/BackofficeTermsPolicies';
import GrapesJSEditor from 'pages/editor-backoffice/EditoBackoffice';
import PageViewer from 'pages/iframe-landing/iframeLanding';
import PageViewer135K from 'pages/iframe-landing-135k/iframeLanding';
import PageViewerSupport from 'pages/iframe-landing-support/iframeLanding-support';
import PageViewerPrivacy from 'pages/iframe-landing-privacy/iframeLanding-privacy';
import PageViewerTerminos from 'pages/iframe-landing-terminos/iframeLanding-terminos';
import MainLayout from './layouts/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import WaitlistTable from './components/WaitlistTable';
import ResponsiveMenu from './components/ResponsiveMenu';
import PageSupport from 'pages/iframe-support/iframeLanding';
import PageAmbassadors from 'pages/iframe-ambassadors/iframeAmbassadors';
import PageGroomers from 'pages/iframe-groomers/iframeGroomers';
import PageShelters from 'pages/iframe-shelters/iframeShelters';
import PageAppLanding from 'pages/iframe-app-landing/iframeAppLanding';
import PageTheApp from 'pages/iframe-the-app/iframeTheApp';
import PageTags from 'pages/iframe-tags/iframeTags';
import PageSmartTag from 'pages/iframe-smart-tag/iframeSmartTag';
import PageAmbassadorApply from 'pages/iframe-ambassador-apply/iframeAmbassadorApply';
import PageAmbassadorHub from 'pages/iframe-ambassador-hub/iframeAmbassadorHub';
import PageGrooming from 'pages/iframe-grooming/iframeGrooming';
import PageTraining from 'pages/iframe-training/iframeTraining';
import PagePricing from 'pages/iframe-pricing/iframePricing';
import PageSolutions from 'pages/iframe-solutions/iframeSolutions';
import PageWhyNoahsArk from 'pages/iframe-why-noahs-ark/iframeWhyNoahsArk';
import PageQrPetTag from 'pages/iframe-qr-pet-tag/iframeQrPetTag';
import PageQrTagActivation from 'pages/iframe-qr-tag-activation/iframeQrTagActivation';
import PageLostFound from 'pages/iframe-lost-found/iframeLostFound';
import PagePetApp from 'pages/iframe-pet-app/iframePetApp';
import PageReuniteTips from 'pages/iframe-reunite-tips/iframeReuniteTips';
import PageFoundPetTips from 'pages/iframe-found-pet-tips/iframeFoundPetTips';
import PageHowToHelp from 'pages/iframe-how-to-help/iframeHowToHelp';

function App() {
  const { user } = useLogin();
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = '';
    let metaDescription = '';

    switch (pathname) {
      case '/':
        title = '';
        metaDescription = '';
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route element={<MainLayout />}>
        <Route path='/' element={<Navigate to="/app-landing" replace />} />
        <Route path='/about' element={<PageViewer pageId='2' />} />
        <Route path='/135k' element={<PageViewer135K pageId='9' />} />
        <Route path='/contact' element={<PageViewer pageId='10' />} />
        <Route path='/faq' element={<PageViewer pageId='11' />} />
        <Route path='/support' element={<PageViewerSupport pageId='12' />} />
        <Route path='/privacy-policy' element={<PageViewerPrivacy pageId='8' />} />
        <Route path='/terms' element={<PageViewerTerminos pageId='13' />} />
        <Route path='/enroll' element={<ErrolPage />} />
        <Route path='/reset_password' element={<ForgotPasswordPage />} />
        <Route path='/privacy-policy' element={<BackofficeTermsPolicies />} />
        <Route path='/policies' element={<Policies />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/petcontests' element={<PageSupport pageId='14' />} />
        <Route path='/ambassadors' element={<PageAmbassadors pageId='15' />} />
        <Route path='/groomers' element={<PageGroomers pageId='16' />} />
        <Route path='/shelters' element={<PageShelters pageId='17' />} />
        <Route path='/app-rewards' element={<PageAppLanding pageId='19' />} />
        <Route path='/app-landing' element={<PageTheApp pageId='18' />} />
        <Route path='/tags' element={<PageTags pageId='20' />} />
        <Route path='/smart-tag' element={<PageSmartTag pageId='21' />} />
        <Route path='/ambassador-apply' element={<PageAmbassadorApply pageId='22' />} />
        <Route path='/ambassador-hub' element={<PageAmbassadorHub pageId='23' />} />
        <Route path='/grooming' element={<PageGrooming pageId='24' />} />
        <Route path='/training' element={<PageTraining pageId='25' />} />
        <Route path='/pricing' element={<PagePricing pageId='26' />} />
        <Route path='/solutions' element={<PageSolutions pageId='27' />} />
        <Route path='/why-noahs-ark' element={<PageWhyNoahsArk pageId='28' />} />
        <Route path='/qr-pet-tag' element={<PageQrPetTag pageId='29' />} />
        <Route path='/qr-tag-activation' element={<PageQrTagActivation pageId='30' />} />
        <Route path='/lost-found' element={<PageLostFound pageId='4' />} />
        <Route path='/pet-app' element={<PagePetApp pageId='3' />} />
        <Route path='/reunite-tips' element={<PageReuniteTips pageId='5' />} />
        <Route path='/found-pet-tips' element={<PageFoundPetTips pageId='6' />} />
        <Route path='/how-to-help' element={<PageHowToHelp pageId='7' />} />
      </Route>

      {/* Rutas protegidas */}
      <Route
        path="/backoffice"
        element={
          <ProtectedRoute>
            <ResponsiveMenu />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/backoffice/request-list" replace />} />
        <Route path="request-list" element={<Backoffice />} />
        <Route path="editor" element={<GrapesJSEditor />} />
        <Route path="waitlist" element={<WaitlistTable />} />
      </Route>
    </Routes>
  );
}

export default App;
